import { LegalPage, LegalSection } from "@/components/site/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" updated="24 August 2026" testId="privacy-policy-page">
      <LegalSection title="1. Who we are">
        <p>
          Globus Financial Services ("Globus", "we", "us") is an independent debt advisory practice based in
          Sahibabad, Uttar Pradesh, India (GSTIN: 09AEFPK4400F1ZW). We help corporates and individuals identify, structure and
          apply for loans from banks, NBFCs and other lending institutions.
        </p>
      </LegalSection>

      <LegalSection title="2. Information we collect">
        <p>When you submit an enquiry or contact us, we collect the details you provide:</p>
        <p>
          Name, phone number, email address, city, the type and amount of loan you are seeking, and any message
          you choose to share. If you use our calculators, the figures you enter are processed in your browser and
          are not stored by us.
        </p>
      </LegalSection>

      <LegalSection title="3. How we use your information">
        <p>We use your information only to:</p>
        <p>
          Respond to your enquiry and discuss suitable loan options; prepare and present loan applications to
          lending partners at your request; and communicate with you about your enquiry by phone, email or
          WhatsApp. We do not use your details for unrelated marketing, and we do not sell your data to anyone.
        </p>
      </LegalSection>

      <LegalSection title="4. Sharing with lending partners">
        <p>
          Where you ask us to arrange a loan, we share relevant details with banks, NBFCs or financial
          institutions strictly for evaluating and processing your application. Each lender's own privacy policy
          governs how they handle your information thereafter.
        </p>
      </LegalSection>

      <LegalSection title="5. Data security and retention">
        <p>
          Enquiry data is stored on secured servers with access restricted to our advisory team. We retain
          enquiry records only for as long as needed to serve you and meet legal or regulatory obligations, after
          which they are deleted.
        </p>
      </LegalSection>

      <LegalSection title="6. Cookies">
        <p>
          This website does not use advertising or tracking cookies. Only technically necessary storage (such as
          the advisor's login session) is used.
        </p>
      </LegalSection>

      <LegalSection title="7. Your rights">
        <p>
          You may ask us at any time to access, correct or delete the personal information we hold about you by
          writing to info@globusfinancialservices-in.com or calling +91 87965 12777.
        </p>
      </LegalSection>

      <LegalSection title="8. Changes and contact">
        <p>
          We may update this policy from time to time; the latest version will always appear on this page. For
          any privacy concern, contact us at info@globusfinancialservices-in.com
        </p>
        <p>
          Globus Financial Services<br />
          HC-3, 3rd Floor, Durga Apartment<br />
          761 Shalimar Garden Ext-1, Sahibabad<br />
          Ghaziabad, Uttar Pradesh-201005, India.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
